if ( typeof ProductItem !== 'function' ) {
  
  class ProductItem extends HTMLElement {
    
    constructor() {
      super();
      this.init();
    }
    
    init() {
      const item = this;
      const video = item.querySelector('.product-item__image-secondary video');
      
      // only handle video element if it exists and device can have hover states
      if (video && window.matchMedia( '(hover: hover)' ).matches) {
        
        video.setAttribute('preload', 'auto');
        let videoTimeout = undefined;
        
        item.addEventListener("mouseenter", (e) => {
          
          // clear video pause if timeout exists
          if (typeof videoTimeout === "number") {
            clearTimeout(videoTimeout);
          }
          
          // reset video and play
          video.currentTime = 0;
          video.play();
        });
        
        item.addEventListener("mouseleave", (e) => {
          
          // pause and reset video after delay
          videoTimeout = setTimeout(() => {
            video.pause();
            video.currentTime = 0;
          }, 500);
        });
      }
    }
  }
  
  if ( typeof customElements.get('product-item') == 'undefined' ) {
    customElements.define('product-item', ProductItem);
  }
}